export const headerConfig = () => {
  const accessToken = localStorage.getItem("access_token") || null;
  let headersObj = {
    headers: {
      "x-access-token": `${accessToken}`,
      'Content-Type': 'application/json'
    },
  };
  return headersObj;
};

export const formHeaderConfig = () => {
  const accessToken = localStorage.getItem("access_token") || null;
  return {
    headers: {
      "x-access-token": `${accessToken}`,
      'Content-Type': 'multipart/form-data'
    },
  };
};
